import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-risk-factors',
  templateUrl: './risk-factors.component.html',
  styleUrls: ['./risk-factors.component.scss']
})
export class RiskFactorsComponent implements OnInit {
  riskData={
    section1:[
          {
            heading:"Statutory Details",
            content:"ITI Mutual Fund is set up as a Trust under the Indian Trust Act, 1882 and SEBI vide Registration No. MF/073/18/01 dated May 14, 2018, has granted registration for ITI Mutual Fund under the provisions of SEBI (Mutual Funds) Regulations, 1996."
          },
          {
            heading:"Sponsors",
            content:"ITI Mutual Fund is sponsored by The Investment Trust of India Limited (erstwhile, Fortune Financial Services (India) Limited) and Fortune Credit Capital Limited. The Sponsors are the Settlor of the Mutual Fund Trust. The Sponsors have entrusted a sum of Rs.1,00,000/- (Rs. One Lakh only) to ITI Mutual Fund Trustee Private Limited (the Trustee Company) as the initial contribution towards the corpus of the Mutual Fund."
          },
          {
            heading:"Trustee",
            content:"ITI Mutual Fund Trustee Private Limited, a Company incorporated under the Companies Act, 2013."
          },
          {
            heading:"Investment Manager",
            content:"ITI Asset Management Limited, a company incorporated under the Companies Act, 1956."
          },
    ],
    section2:[
          {
            content:"Investment in Mutual Fund units involves investment risks such as trading volumes, settlement risk, liquidity risk, default risk including the possible loss of principal and uncertainty of dividend distribution."
          },
          {
            content:"As the price/value/interest rates of the securities in which the Schemes invest fluctuate, the value of your investment in the Schemes may go up or down."
          },
          {
            content:"The name of the Schemes referred to in the website or their respective Scheme Information Documents (SID) are only the names of the schemes and do not in any manner indicate either the quality of the scheme or their future prospects or returns."
          },
          {
            content:"Past performance of the Sponsors/AMC/Mutual Fund does not guarantee future performance of the Schemes and may not necessarily provide a basis of comparison with other investments."
          },
          {
            content:"The Sponsors are not responsible or liable for any loss resulting from the operation of the Schemes beyond the initial contribution of Rs.1,00,000 made by it towards setting up the Fund."
          },
          {
            content:"All Mutual Fund and securities investments are subject to market risk and there can be no assurance that the Schemes’ objectives will be achieved. "
          },
          {
            content:"Investors are not being offered any guaranteed/assured returns under any scheme of ITI Mutual Fund."
          },
          {
            content:" Investors may obtain Statement of Additional Information, Scheme Information Document and Key Information Memorandum of respective schemes along with application forms from our Investor Service Centre as well as from our website www.itiamc.com."
          }
      ]
  };


  constructor() { }

  ngOnInit() {
   this.scrollTop();
  }

  scrollTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

}
